import { createSlice } from "@reduxjs/toolkit";

type DesignPortalSettings = {};

type DesignPortalState = {
  open: boolean;
  isLocked: boolean;
  arrayDataTableExpanded: boolean;
} & DesignPortalSettings;

let initialState: DesignPortalState = {
  open: false,
  isLocked: false,
  arrayDataTableExpanded: false,
};

const designPortalSlice = createSlice({
  name: "designPortal",
  initialState,
  reducers: {
    open(state) {
      state.open = true;
    },
    close(state) {
      state.open = false;
    },
    lockDesign(state) {
      state.isLocked = true;
    },
    unlockDesign(state) {
      state.isLocked = false;
    },
    expandArrayDataTable(state) {
      state.arrayDataTableExpanded = true;
    },
    closeArrayDataTable(state) {
      state.arrayDataTableExpanded = false;
    },
    toggleArrayDataTable(state) {
      state.arrayDataTableExpanded = !state.arrayDataTableExpanded;
    },
  },
});

export const {
  open: openDesignPortal,
  close: closeDesignPortal,
  lockDesign,
  unlockDesign,
  toggleArrayDataTable,
  closeArrayDataTable,
  expandArrayDataTable,
} = designPortalSlice.actions;

export default designPortalSlice;
